import { Box } from '@mui/material'
import React, { ReactElement } from 'react'
import { AppBrand } from '../AppBrand/AppBrand'
import { AppSettings } from '../AppSettings/AppSettings'

export type IHeader = {
  moduleTitle: string
  moduleIcon?: any
  children: ReactElement
}
export const Header: React.FC<IHeader> = ({
  moduleTitle,
  moduleIcon,
  children,
}) => {
  return (
    <Box
      component='header'
      display='grid'
      alignItems='center'
      gridTemplateColumns='auto 1fr auto'
      gap={4}
      py={3}
      px={4}
    >
      <AppBrand title={moduleTitle} icon={moduleIcon} />
      {children}
      <Box display='grid' gridTemplateColumns='1fr auto'>
        <AppSettings />
      </Box>
    </Box>
  )
}
